export default __webpack_public_path__ + "static/media/dropdown-arrow-down.0b915681.svg";